import React from 'react';
import EditorChrome from './EditorChrome';

const Contact = () => (
    <main className="container portfolio-shell inner-shell">
        <EditorChrome active="/Contact" />
        <section className="inner-editor contact-page Contact">
            <a className="back-link" href="/">Back to homepage</a>
            <div className="page-heading">
                <p>;; Open to research, engineering, and collaboration</p>
                <h1>Contact</h1>
                <span>The fastest way to reach me is by email. You can also find my research, code, and professional profiles below.</span>
            </div>

            <div className="contact-primary">
                <a href="mailto:milan@marcellovalentino.com">
                    <span>Email</span><strong>milan@marcellovalentino.com</strong><i>↗</i>
                </a>
            </div>

            <div className="contact-sections">
                <section>
                    <h2>Profiles & work</h2>
                    <div className="contact-actions">
                        <a className="btn" href="https://github.com/MilanMarocchi" target="_blank" rel="noreferrer">GitHub</a>
                        <a className="btn" href="https://www.linkedin.com/in/milan-marocchi-3785b1215/" target="_blank" rel="noreferrer">LinkedIn</a>
                        <a className="btn" href="https://scholar.google.com/scholar?q=Milan+Marocchi" target="_blank" rel="noreferrer">Google Scholar</a>
                        <a className="btn" href="https://birdrone.com.au" target="_blank" rel="noreferrer">BIRDRONE</a>
                    </div>
                </section>
                <section>
                    <h2>Portfolio</h2>
                    <div className="contact-actions">
                        <a className="btn" href="/Publications">Publications</a>
                        <a className="btn" href="/GitHub">GitHub Projects</a>
                        <a className="btn" href="/Archive">Project Archive</a>
                    </div>
                </section>
                <section>
                    <h2>Documents</h2>
                    <div className="contact-actions">
                        <a className="btn" href="/Documents/Resume.pdf" target="_blank" rel="noreferrer">Résumé</a>
                        <a className="btn" href="/Documents/CV.pdf" target="_blank" rel="noreferrer">Full Curriculum Vitae</a>
                        <a className="btn" href="/Documents/LaTeX-source.zip" download>LaTeX sources</a>
                        <a className="btn" href="/Documents/transcript.pdf" target="_blank" rel="noreferrer">Academic Transcript</a>
                    </div>
                </section>
            </div>
        </section>
    </main>
);

export default Contact;
